export const serviceId = "service_47xcs0b";
export const templateId = "template_sm8wmp1";
export const userId = "6-uVf9seg-tQs7JtK";
